import Tag from "@/components/base/Tag";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
  onOpen: (item: NewsItem) => void;
  layout?: "row" | "card";
}

export default function NewsCard({ item, onOpen, layout = "row" }: NewsCardProps) {
  if (layout === "card") {
    return (
      <button
        type="button"
        onClick={() => onOpen(item)}
        className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left transition-colors hover:border-primary-300"
      >
        <div className="relative h-48 w-full overflow-hidden">
          <img
            src={item.image}
            alt={`${item.title} - 佐佐木明希明星资讯配图`}
            title={`${item.title} 佐佐木明希 明星资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-1 flex-col p-5">
          <div className="flex items-center gap-2">
            <Tag tone="primary">{item.type}</Tag>
            <span className="text-xs text-foreground-500">{item.date}</span>
          </div>
          <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-label font-medium text-primary-600">
            阅读全文
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </span>
        </div>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="group flex w-full flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 text-left transition-colors hover:border-primary-300 sm:flex-row sm:gap-6 sm:p-5"
    >
      <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-md sm:h-32 sm:w-52">
        <img
          src={item.image}
          alt={`${item.title} - 佐佐木明希明星资讯配图`}
          title={`${item.title} 佐佐木明希 明星资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <Tag tone="primary">{item.type}</Tag>
          <span className="text-xs text-foreground-500">{item.date}</span>
        </div>
        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-label font-medium text-primary-600">
          阅读详情
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </span>
      </div>
    </button>
  );
}